import React, { useEffect, useState, useContext, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useQuery, useMutation } from "@tanstack/react-query";
import { beusable, callFinish } from "../common";
import { getKbQuestion, setKbSurvey } from "../api";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Popup from "../components/Popup";
import Store from "../context/Store";

function Detail(props) {
  const { state } = useContext(Store);
  const [btnShow, setBtnShow] = useState(false);
  const [surveyItems, setSurveyItems] = useState({});
  const navigate = useNavigate();
  const { title, directive, surveyId } = useLocation().state;
  let surveyItem = [];

  useEffect(() => {
    beusable();
  }, []);

  const radioEvent = () => {
    surveyItem = [];
    for (let index = 0; index < question.data.length; index++) {
      const el = document.getElementsByName(`rd0${index + 1}`);
      for (var i = 0; i < el.length; i++) {
        if (el[i].checked) {
          surveyItem.push(el[i].value);
        }
      }
    }
    if (question.data.length === surveyItem.length) {
      setSurveyItems({
        surveyItems: surveyItem,
        surveyId: surveyId,
        token: state.token,
        userGroup: state.userGroup,
      });
      setBtnShow(true);
    }
  };

  const saveSurvey = useMutation({
    mutationFn: (surveyItems) => setKbSurvey(surveyItems),
    onSuccess: () => {
      navigate("/findme/result", { state: { surveyId: surveyId } });
    },
    onError: (error) => {
      return <Popup type={"alert"} msg={error.message} />;
    },
  });

  const setSurvey = useCallback(() => saveSurvey.mutate(surveyItems), [saveSurvey, surveyItems]);

  const {
    isLoading,
    data: question,
    error,
  } = useQuery({ queryKey: ["question", surveyId], queryFn: () => getKbQuestion(state, surveyId) });

  if (isLoading) {
    return null;
  }

  if (error) {
    return <Popup type={"alert"} msg={error.message} onClick={() => callFinish({})} />;
  }

  return (
    <>
      {question.code !== 200 ? (
        <Popup type={"alert"} msg={question.msg} />
      ) : (
        <>
          <Header userGroup={state.userGroup} title={title} />
          <div className="content-wrap">
            <div className="content scrollBox">
              <div className="mental-test">
                <p className="tip-recom">{directive}</p>
                {question.data.map((data, index) => (
                  <div className="survey-box" key={index}>
                    <p className="survey-box-title">
                      <strong>{index + 1}. </strong>
                      {data.content}
                    </p>
                    <div
                      className={
                        data.surveyId === 8 || data.surveyId === 14
                          ? "btn-survey-list"
                          : "btn-survey-radio type-col"
                      }
                    >
                      {data.item.map((item) => (
                        <p
                          className={data.surveyId === 8 || data.surveyId === 14 ? "" : "ipt-rdo"}
                          key={item.id}
                        >
                          <input
                            type="radio"
                            name={"rd0" + (index + 1)}
                            value={item.id}
                            id={item.id}
                            onChange={radioEvent}
                          />
                          <label htmlFor={item.id}>{item.content}</label>
                        </p>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <Footer btnShow={btnShow} onClick={setSurvey} />
        </>
      )}
    </>
  );
}

export default Detail;
